@if (!product) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
@if (product) {
  <mat-card class="product-details-page content">
    <div class="content-header title">
      <div class="flex-row">
        <div
          style="cursor: pointer"
        (click)="
          this.clipboardService.copyUrlAndTextToClipboard(
            this.urlService.getFullUrl(),
            this.pageLink
          )
        "
          >
          <div matTooltip="Page Link" matTooltipPosition="right">
            {{
            !product.barcode ? product.reference : product.barcode
            }}
            <mat-icon>link</mat-icon>
          </div>
        </div>
        <div class="spacer"></div>
        @if (authService.hasPermission(Permission.ProductsLifecycleFull)) {
          <button
            mat-stroked-button
            color="primary"
            (click)="openLifecycle()"
            matTooltip="Product Lifecycle"
            matTooltipPosition="below"
          >
            <mat-icon>account_tree</mat-icon>
            Lifecycle
          </button>
        }
        <h4 class="router-link" (click)="onBack()">
          {{ backToCollection ? "Back to Collection" : "Back to Job" }}
        </h4>
      </div>
    </div>
    <div class="minor-header"></div>
    <mat-expansion-panel expanded="true" hideToggle disabled>
      @if (!authService.hasPermission(Permission.PostAssetsPreRelease)) {
        <br />
      }
      @if (authService.hasPermission(Permission.PostAssetsPreRelease)) {
        <mat-expansion-panel-header
          style="overflow: visible; align-items: center"
          >
          <div
            class="product-details-page__key"
            (click)="copyToClipboard(product.key, 'key')"
            >
            @if (product.key) {
              <mat-icon
                class="product-details-page__copy"
                (click)="copyToClipboard(product.key, 'key')"
                >content_copy</mat-icon
                >
              }
              {{ product.key }}
            </div>
            <span class="spacer"></span>
            <button
              mat-icon-button
              matbadgeColor="warn"
              color="primary"
              matTooltip="Notes"
              matTooltipPosition="above"
              [matMenuTriggerFor]="notes"
              >
              <mat-icon
                matBadge="!"
                matBadgePosition="above after"
                [matBadgeHidden]="product.notes == null || product.notes.length == 0"
                >edit_note</mat-icon
                >
              </button>
              <app-edit-action
                [product]="product"
                [displayMode]="'icon-button'"
              ></app-edit-action>
              <mat-menu #notes="matMenu" class="menu">
                <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
                  >
                  <h1 style="padding: 0 10px 0 10px; margin: 0px">Notes</h1>
                  <button
                    style="margin-right: 10px"
                    mat-icon-button
                    (click)="patchProductNotes(product)"
                    color="success"
                    >
                    <mat-icon>save</mat-icon>
                  </button>
                </div>
                <div style="width: 320px" (click)="$event.stopPropagation()">
                  <mat-form-field
                    appearance="outline"
                    style="width: 300px; padding: 10px"
                    subscriptSizing="dynamic"
                    >
                    <textarea
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      [(ngModel)]="product.notes"
                      matInput
                      cdkAutosizeMinRows="1"
                    ></textarea>
                  </mat-form-field>
                </div>
              </mat-menu>
            </mat-expansion-panel-header>
          }
          <mat-grid-list cols="2" rowHeight="60" gutterSize="20">
            <mat-grid-tile class="w-100">
              <mat-form-field
                appearance="outline"
                color="primary"
                class="w-100"
                subscriptSizing="dynamic"
                >
                <mat-label>Barcode</mat-label>
                <input
                  matInput
                  [readonly]="true"
                  value="{{ product.barcode }}"
                  class="w-100"
                  />
                @if (product.barcode) {
                  <button
                    matSuffix
                    mat-icon-button
                    (click)="copyToClipboard(product.barcode, 'barcode')"
                    matTooltip="Copy"
                    matTooltipPosition="above"
                    >
                    <mat-icon class="product-details-page__copy">content_copy</mat-icon>
                  </button>
                }
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile class="w-100">
              <mat-form-field
                appearance="outline"
                color="primary"
                subscriptSizing="dynamic"
                >
                <mat-label>Reference</mat-label>
                <input matInput [readonly]="true" value="{{ product.reference }}" />
                @if (product.reference) {
                  <button
                    matSuffix
                    mat-icon-button
                    (click)="copyToClipboard(product.reference, 'reference')"
                    matTooltip="Copy"
                    matTooltipPosition="above"
                    >
                    <mat-icon class="product-details-page__copy">content_copy</mat-icon>
                  </button>
                }
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" class="w-100">
              <mat-form-field
                appearance="outline"
                color="primary"
                subscriptSizing="dynamic"
                >
                <mat-label>Description</mat-label>
                <input matInput [readonly]="true" value="{{ product.description }}" />
                @if (authService.hasPermission(Permission.PostAssetsPreRelease)) {
                  <button
                    matSuffix
            [disabled]="
              product.productLink == null || product.productLink.length == 0
            "
                    mat-icon-button
                    (click)="openProductLink()"
                    matTooltip="Product Link"
                    matTooltipPosition="above"
            [color]="
              product.productLink == null || product.productLink.length == 0
                ? 'disabled'
                : 'info'
            "
                    >
                    <mat-icon>link</mat-icon>
                  </button>
                }
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile class="w-100">
              <mat-form-field
                appearance="outline"
                color="primary"
                subscriptSizing="dynamic"
                >
                <mat-label>Batch</mat-label>
                <input matInput [readonly]="true" value="{{ product.batchName }}" />
              </mat-form-field>
            </mat-grid-tile>
            @if (authService.hasPermission(Permission.OrganizationsRead)) {
              <mat-grid-tile class="w-100">
                <mat-form-field
                  appearance="outline"
                  color="primary"
                  subscriptSizing="dynamic"
                  >
                  <mat-label>Organization</mat-label>
                  <input
                    matInput
                    [readonly]="true"
                    value="{{ product.organizationName }}"
                    />
                </mat-form-field>
              </mat-grid-tile>
            }
          </mat-grid-list>
        </mat-expansion-panel>
        <div class="product-details-page__content">
          @if (authService.hasPermission(Permission.PostAssetsPreRelease)) {
            <app-product-progress
              [activeStep]="activeStep"
              [config]="stepperConfig"
              (stepChange)="onStepSelected($event)"
            ></app-product-progress>
          }
          @if (activeStep === 'preProduction') {
            <app-step-pre-production
              [product]="product"
            ></app-step-pre-production>
          }
          @if (activeStep === 'production') {
            <app-step-production
              [product]="product"
              [colPerScreen]="colPerScreen"
              [editCallback]="editCallback"
            ></app-step-production>
          }
          @if (activeStep === 'postProduction') {
            <app-step-post-production
              [product]="product"
              [colPerScreen]="colPerScreen"
              [editCallback]="editCallback"
            ></app-step-post-production>
          }
          @if (activeStep === 'outputAssets') {
            <app-step-output-assets
              [product]="product"
              [colPerScreen]="colPerScreen"
              [editCallback]="editCallback"
            ></app-step-output-assets>
          }
        </div>
      </mat-card>
    }
